import Skeleton from "react-loading-skeleton";

const FeedSkeletonLoading = () => {
	return (
		<div className="space-y-4">
			<FeedPostCardSkeletonLoading />
			<FeedPostCardSkeletonLoading />
			<FeedPostCardSkeletonLoading />
		</div>
	);
};

export const FeedPostCardSkeletonLoading = () => {
	return (
		<div className="mx-auto space-y-4 rounded-lg bg-white p-4 shadow">
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-2">
					<Skeleton circle width={32} height={32} />
					<div className="flex-1">
						<Skeleton width={200} />
						<Skeleton width={100} />
					</div>
				</div>
				<div className="flex items-center gap-2">
					<Skeleton width={80} />
					<Skeleton circle width={24} height={24} />
					<Skeleton circle width={24} height={24} />
				</div>
			</div>

			<div>
				<Skeleton width={300} height={24} />
			</div>

			<div>
				<Skeleton count={3} />
			</div>

			<div className="flex items-center justify-between">
				<div className="flex -space-x-2">
					<Skeleton circle width={32} height={32} />
					<Skeleton circle width={32} height={32} />
					<Skeleton circle width={32} height={32} />
				</div>
				<div className="flex items-center gap-2">
					<Skeleton width={50} />
					<Skeleton width={80} />
				</div>
			</div>

			<div className="grid grid-cols-3 gap-4 border-t pt-2">
				<Skeleton height={36} />
				<Skeleton height={36} />
				<Skeleton height={36} />
			</div>
		</div>
	);
};

export default FeedSkeletonLoading;
